// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"Checkbox_checkBox__d81Sp","styled":"Checkbox_styled__10BeK","secondary":"Checkbox_secondary__2irrF","outlined":"Checkbox_outlined__1n4dg"};